import * as c from '../constants/StudentsExamSchedulesConstants'

const initialState = {
  schedules: {},
  fetching: false,
  fetched: false,
  error: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.FETCH_STUDENT_EXAMS_SCHEDULE_PENDING:
      return { ...state, fetching: true, fetched: false, error: null }

    case c.FETCH_STUDENT_EXAMS_SCHEDULE_FULFILLED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        schedules: {
          ...state.schedules,
          [payload.studentId]: payload.data
        }
      }

    case c.FETCH_STUDENT_EXAMS_SCHEDULE_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    default:
      return state
  }
}
